export default function calcularMediaParaAluno(aluno) {
    if (!aluno || !Array.isArray(aluno.avaliacoes)) {
        return 0; // Retornar um valor padrão ou tratar o erro conforme necessário
    }

    let somaPonderadaNotas = 0;
    let somaPesos = 0;

    aluno.avaliacoes.forEach(avaliacao => {
        // Verificação adicional para garantir que os dados da avaliação são válidos
        if (!avaliacao || typeof avaliacao.nota !== 'number') {
            return; // Pula para a próxima iteração do forEach
        }

        if (avaliacao.nota > 0 && avaliacao.nota <= 200) {
            let peso = (avaliacao.tipo_criterio === 1 || avaliacao.tipo_criterio === 2 || avaliacao.tipo_criterio === 3 || avaliacao.tipo === "2") ? 3 : 0.5;
            let nota = avaliacao.nota;
            if(nota === 1){
                nota = nota * 40;
            }
            if(nota == 10){
                nota = nota * 4;
            }
            somaPonderadaNotas += nota * peso;
            somaPesos += peso;
        } else {

        }
    });

    if (somaPesos === 0) {
        return 0; // Evita divisão por zero
    }

    return Math.round(somaPonderadaNotas / somaPesos);
}

